import { useEffect } from 'react';

import { getIsUserAuthorized } from '@telialt/utils/src/SSO/utils';

const OCTOCOM_SESSION_TOKEN_KEY = 'octocom:data:sessionToken';
const OCTOCOM_SESSION_SCOPE_KEY = 'octocom-session-scope';
const CLEAR_OCTOCOM_HISTORY_EVENT_NAME = 'clearOctocomHistory';

export const useOctocomSession = () => {
    useEffect(() => {
        const isLoggedIn = getIsUserAuthorized();

        if (isLoggedIn) {
            if (window.localStorage.getItem(OCTOCOM_SESSION_SCOPE_KEY)?.startsWith('logged-out-')) {
                window.localStorage.setItem(OCTOCOM_SESSION_SCOPE_KEY, crypto.randomUUID());
                window.dispatchEvent(new Event(CLEAR_OCTOCOM_HISTORY_EVENT_NAME));
            }
        } else {
            if (!!window.localStorage.getItem(OCTOCOM_SESSION_TOKEN_KEY)) {
                window.localStorage.removeItem(OCTOCOM_SESSION_TOKEN_KEY);
            }

            if (!window.localStorage.getItem(OCTOCOM_SESSION_SCOPE_KEY)?.startsWith('logged-out-')) {
                window.localStorage.setItem(OCTOCOM_SESSION_SCOPE_KEY, `logged-out-${crypto.randomUUID()}`);
                window.dispatchEvent(new Event(CLEAR_OCTOCOM_HISTORY_EVENT_NAME));
            }
        }
    }, []);
};
